// src/config/env.js

/**
 * The app's single point of contact with build-tool environment injection.
 *
 * Vite exposes build-time values on `import.meta.env`. The REACT_APP_ prefix is
 * kept rather than renamed to VITE_, because these names are also defined in the
 * Netlify dashboard and in netlify.toml; `envPrefix` in vite.config.js accepts
 * both, so they can be renamed later without a flag day. Routing every read
 * through this module is what kept the migration to one file instead of sixty.
 *
 * Values are read once at module load. That is what the call sites already did
 * with their own module-scope constants, and it is what `vitest.config.js`
 * feeds through its `test.env` block.
 */

/** Backend base URL. No trailing slash; callers append `/v1/...`. */
export const API_URL = import.meta.env.REACT_APP_API_URL || '';

/** QR / short-URL resolver host, trailing slashes stripped. */
export const QR_BASE_URL = (
  import.meta.env.REACT_APP_QR_BASE_URL || 'https://mntl.at'
).replace(/\/+$/, '');

/** OAuth2 client for the admin SPA. Both ship in the bundle — see README. */
export const ADMIN_CLIENT_ID = import.meta.env.REACT_APP_ADMIN_CLIENT_ID;
export const ADMIN_CLIENT_SECRET = import.meta.env.REACT_APP_ADMIN_CLIENT_SECRET;

/**
 * True only under `npm start`, for diagnostics that should not ship.
 *
 * Deliberately `MODE`, not `import.meta.env.DEV`: DEV is also true under Vitest,
 * which would switch on dev-only logging and the `LOCAL:` document-title prefix
 * during tests. MODE is 'development', 'production' or 'test', so this keeps the
 * exact meaning the old `NODE_ENV === 'development'` check had.
 */
export const IS_DEVELOPMENT = import.meta.env.MODE === 'development';

/**
 * URL for a file served out of `public/`.
 *
 * Joining the base path by hand is a trap here: CRA's `PUBLIC_URL` had no
 * trailing slash, while Vite's `BASE_URL` is `/`, so
 * `` `${base}/images/x.png` `` silently becomes `//images/x.png`. This
 * normalises both ends instead.
 */
export function publicPath(path) {
  const base = (import.meta.env.BASE_URL || '').replace(/\/+$/, '');
  return `${base}${path.startsWith('/') ? path : `/${path}`}`;
}
